import React, { useEffect, useState } from "react";
import Link from "@/components/Link";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import { Button } from "@dxp-feed/ui/Button";
import AnimatedQuantityButton from "@/components/QuantityButton";
import FavoriteButton from "@/components/FavoriteButton";
import ImageWrapper from "@/components/ImageWrapper";
import OfferCard from "@/components/OfferCard";
import { searchBySingleIndex } from "@/services/algolia";
import { ProductType } from "@/utils/types/product";
import { useStoreDetails } from "@/utils/hooks/useStoreDetails";
import { dataLayerProductViewList } from "@/helpers/dataLayer";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { ALGOLIA_INDEXES } from "@/services/algolia/config";
import AdSlot from "@/helpers/gpt";
import { adsScript } from "@/utils/adsTempConstant";
import { getAlcoholStoreFilter } from "@/helpers/productsFilterHelper";

interface FreshBread {
  columnControl: any;
}

const fetchProductsAEMData = async (productIds: any, storeID: any) => {
  if (!Array.isArray(productIds) || productIds.length === 0) {
    return;
  }

  const itemsQuery = productIds
    .map((id: string) => `articleNumber:${id}`)
    .join(" OR ");

  try {
    console.log(storeID,"storeID")
    const productData = await searchBySingleIndex({
      indexName: ALGOLIA_INDEXES.PRODUCTS.PRIMARY_INDEX,
      searchParams: {
        filters: `(${itemsQuery}) AND storeId:"${storeID}" AND isMassOffers:false AND isVisible:true`,
      },
    });

    const products = productData?.hits || [];
    console.log(products, itemsQuery,"productss")
    return products.slice(0, 6)
  } catch (err: any) {
    console.log("error:", err);
  }
};

export default function FreshBread({
  columnControl,
  productIds,
  displayedFrom,
  homeProductData,
  sectionTitle
}: {
  columnControl: any;
  productIds?: string[];
  displayedFrom?:string;
  homeProductData?:any;
  sectionTitle?: string;
}) {
  const [productsData, setProductsData] = useState<ProductType[]>([]);

  const { storeID,storeRegion } = useStoreDetails();

  const fetchData = async () => {
    if (!Array.isArray(productIds) || productIds?.length === 0) {
      return;
    }

    const itemsQuery = productIds
      .map((id: string) => `articleNumber:${id}`)
      .join(" OR ");

      const filters = `(${itemsQuery}) AND ${getAlcoholStoreFilter(storeID, storeRegion)}`;
    try {
      const productData = await searchBySingleIndex({
        indexName: ALGOLIA_INDEXES.PRODUCTS.PRIMARY_INDEX,
        searchParams: {
          filters: filters,
        },
      });

      const products = productData?.hits || [];

      setProductsData(products.slice(0, 6));
    } catch (err: any) {
      console.log("error:", err);
    }
  };

  useEffect(() => {
  if (displayedFrom == "homeContentPage") {
      setProductsData(homeProductData?.slice(0, 6))
    } else {
      fetchData();
    }
  }, [productIds, storeID,homeProductData]);

  const [visibleItems, setVisibleItems] = useState<Set<string>>(new Set());
  const [pendingItems, setPendingItems] = useState<Set<string>>(new Set());
  const [isAllProductCapture, setIsAllProductCapture] = useState(false);
  const [lastSentItems, setLastSentItems] = useState<Set<string>>(new Set());
  const path = useAppSelector((state) => state?.adsSclice?.page ?? "");

  const handleVisibilityChange = (item: any, isVisible: boolean) => {
    const itemString = JSON.stringify(item);

    if (isAllProductCapture) return;

    if (isVisible) {
      setVisibleItems((prev) => {
        const newVisible = new Set(prev);
        newVisible.add(itemString);
        return newVisible;
      });
      setPendingItems((prev) => {
        const newPending = new Set(prev);
        newPending.delete(itemString);
        return newPending;
      });
    } else {
      setPendingItems((prev) => {
        const newPending = new Set(prev);
        newPending.add(itemString);
        return newPending;
      });
      setVisibleItems((prev) => {
        const newVisible = new Set(prev);
        newVisible.delete(itemString);
        return newVisible;
      });
    }
  };

  useEffect(() => {
    if (isAllProductCapture || visibleItems.size === 0) return;
    const newItems = new Set(
      [...visibleItems].filter((x) => !lastSentItems.has(x))
    );
    if (newItems.size > 0) {
      const products = Array.from(newItems).map((item) => JSON.parse(item));
      dataLayerProductViewList({
        event: "view_item_list",
        ecommerce: {
          item_list_id: "1",
          item_list_name: "Homepage - Products",
          items: products,
        },
      });
      setLastSentItems((prev) => new Set([...prev, ...newItems]));
    }
    if (visibleItems.size === productsData?.length) {
      setIsAllProductCapture(true);
    }
  }, [visibleItems, isAllProductCapture, productsData?.length, lastSentItems]);

  const { isLoading } = useAppSelector((state) => state.gigyaslice);

  return (
    <Box as="div" className="recipes-outer-section bg-brandWhite">
      <Box as="div" className="recipes-for-you-section">
        <Box
          as="div"
          className="recipes-items-outer grid xl:grid-cols-2 gap-6 pr-[0px] lg:pr-[0px] lg:gap-[24px] md:gap-[16px]"
        >
          <Box
            as="div"
            className="recipes-featured-block overflow-hidden flex flex-col items-start rounded-xl pr-[24px] 2md:pr-[48px] lg:pr-0"
          >
            <AdSlot
              Fallback={
                <Box
                  as="div"
                  className="imageouter w-full bg-grey300 rounded-t-xl grow"
                >
                  <ImageWrapper
                    src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL}${columnControl?.["column-1"]?.[":items"]?.bscards?.image}`}
                    width={708}
                    height={464}
                    className="w-full h-full rounded-t-xl !relative"
                    alt="Freshly baked bread"
                  />
                </Box>
              }
              id={adsScript?.[path]?.AdCard?.id}
            />
            <Box
              as="div"
              className="recipes-featured-block-desc p-[16px] md:p-[32px] lg:py-[56px] bg-brandSecondary w-full rounded-b-xl"
            >
              <Text
                as="h3"
                className="text-brandWhite text-2xl font-bold leading-normal font-sans mb-[4px] md:mb-[8px] "
              >
                {columnControl?.["column-1"]?.[":items"]?.bscards?.heading}
              </Text>
              <Text
                as="p"
                className="text-brandWhite text-base font-normal leading-normal mb-[16px] md:mb-[24px]"
              >
                {columnControl?.["column-1"]?.[":items"]?.bscards?.description
                  ? new DOMParser().parseFromString(
                      columnControl?.["column-1"]?.[":items"]?.bscards
                        ?.description,
                      "text/html"
                    )?.body?.textContent
                  : ""}
              </Text>
              <Button variant="outlineWhite" asChild>
                {columnControl?.["column-1"]?.[":items"]?.bscards?.ctaList[0]
                  ?.link && (
                  <Link
                    className="font-normal bg-brandWhite text-brandSecondary border-[1px] focus:text-brandWhite hover:text-brandWhite border-brandWhite before:bg-brandSecondary !text-body  px-[24px]"
                    href={
                      columnControl?.["column-1"]?.[":items"]?.bscards
                        ?.ctaList[0]?.link || "#"
                    }
                    target={
                      columnControl?.["column-1"]?.[":items"]?.bscards
                        ?.ctaList[0]?.target
                    }
                    aria-label={
                      columnControl?.["column-1"]?.[":items"]?.bscards
                        ?.ctaList[0]?.ariaLabel
                    }
                  >
                    {
                      columnControl?.["column-1"]?.[":items"]?.bscards
                        ?.ctaList[0]?.linkTitle
                    }
                  </Link>
                )}
              </Button>
            </Box>
          </Box>
          {!isLoading && 
          <Box
            as="div"
            className="recipes-featured-cards-row fresh-main py-[4px] lg:pb-[1px] lg:py-[1px] pl-[2px] pr-6 lg:pr-[1px] xl:px-[1px] flex-row flex overflow-x-auto lg:overflow-x-visible lg:grid grid-cols-3 gap-[8px] lg:gap-[24px]"
          >
            {productsData?.map((products: any, index: number) => (
              <OfferCard
                key={products.objectID}
                item={products}
                onVisibilityChange={handleVisibilityChange}
                viewItemList={"Homepage - Products"}
                viewItemListId={"1"}
                datalayerTitle={sectionTitle}
                itemPosition={index + 1}
                />
            ))}
          </Box>
          }
        </Box>
      </Box>
    </Box>
  );
}


export {fetchProductsAEMData};